import RestClient from './RestClient';
import { Shift, User } from '../../models';
import store from '../../redux';
import { getRequestInstanceQueryValue } from '../requestInstance';

class Shifts extends RestClient {
    constructor() {
        super({
            "model": Shift,
            "entryPoint": "shift",
            "resource": "shift",
            "resources": "shifts",
            "id": "id"
        });
    }

    icsLink(params) {
        const link = new URL(`${this.baseUrl}/shift/ics`);
        const user = store.getState().auth.user;
        if (user?.api_key)
            link.searchParams.append('x-api-key', user.api_key);

        const tkt_instance = getRequestInstanceQueryValue();
        if (tkt_instance)
            link.searchParams.append('tkt_instance', tkt_instance);

        if (!params)
            return link.href;

        if (params.application_types_ids) {
            const ids = Array.isArray(params.application_types_ids)
                ? params.application_types_ids
                : [params.application_types_ids];
            const joined = ids.filter(Boolean).join(',');
            if (joined)
                link.searchParams.append('application_types_ids', joined);
        }

        ['phase_id', 'sector_id', 'sector_id_in'].forEach((key) => {
            if (params[key])
                link.searchParams.append(key, params[key]);
        });

        return link.href;
    }

    loadSuggestion(user_id) {
        return this.GET('/shift/suggestion', { user_id })
            .then(response => response.json())
            .then(json => {
                if (json.suggestion)
                    return {
                        ...json,
                        suggestion: new User(json.suggestion)
                    };
                throw new Error(json.flash.error);
            });
    }
}

const ShiftsApi = new Shifts();

export default ShiftsApi;
